import { assert_string_object_id, assert_type_enum } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__workspace_entity } from './_enums/ENUM__workspace_entity';

export class DTOWorkspaceChildEntityViewer extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.WORKSPACE_CHILD_ENTITY_VIEWER;

  /*
   * STATIC METHODS
   */
  static sort_by_viewer_id(a: DTOWorkspaceChildEntityViewer, b: DTOWorkspaceChildEntityViewer) {
    return a.get_viewer_id().localeCompare(b.get_viewer_id());
  }

  /*
   * FIELDS FILL ON CLIENT
   */
  workspace_id!: string;
  entity_id!: string;
  entity_type!: string;

  is_view!: boolean;

  /*
   * FIELDS FILL ON SERVER
   */
  workspace_user_id!: string;
  user_id!: string;
  connection_id!: string;

  viewer_type!: string;

  user_name!: string;
  user_avatar_url_relative!: string;

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    assert_string_object_id(this.workspace_id);
    assert_string_object_id(this.entity_id);
    assert_type_enum(this.entity_type, ENUM__workspace_entity);
  }

  get_viewer_id() {
    let out = '';

    if (this.workspace_user_id) {
      out = this.workspace_user_id;
    } else if (this.user_id) {
      out = this.user_id;
    } else {
      out = this.connection_id;
    }

    return out;
  }
}
